var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"aa883049b119cf429eac3444c5508aba2d61d382"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["wally@skycatchfire"]={id:"aa883049b119cf429eac3444c5508aba2d61d382"};
      